import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatSnackBar } from '@angular/material';
import { CarteraService } from 'app/services/cartera/cartera.service';
import { NgModel } from '@angular/forms';
import * as moment from 'moment';
@Component({
  selector: 'app-observacion-cartera-grupo',
  templateUrl: './observacion-cartera-grupo.component.html',
  styleUrls: ['./observacion-cartera-grupo.component.scss']
})
export class ObservacionCarteraGrupoComponent implements OnInit {

  public observacion_cartera: string;
  public observacion_contrato: string;
  public disabled: boolean = true;
  @ViewChild('InputObsContrato',{static:true}) observacionesContrato:NgModel;
  @ViewChild('InputObsCartera',{static:true}) observacionesCartera:NgModel;
  /**
   * Constructor
   * 
   * @param _data 
   * @param {CarteraService} _cartera 
   * @param {MatDialogRef<ObservacionCarteraGrupoComponent>} dialog 
   * @param {MatSnackBar} _snackBar 
   */
  constructor
  (
    @Inject(MAT_DIALOG_DATA) private _data, 
    private _cartera: CarteraService,
    public dialog: MatDialogRef<ObservacionCarteraGrupoComponent>,
    private _snackBar: MatSnackBar
  ) 
  {}

  // -----------------------------------------------------------------------------------------------------
  // @ Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On Init
   */
  ngOnInit() {
    this._cartera.VerObservacionesGrupo(this._data.base_datos, this._data.grunit, this._data.grugru)
                  .subscribe((data: Array<any>) => {
                              this.observacion_cartera = data[0].observacion_cartera;
                              this.observacion_contrato = data[0].observacion_contrato;
                  });
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * Modifica la observacion del grupo, añadiendo nuevas observaciones.
   * @param {string} cartera 
   * @param {string} contrato
   */
  public guardarObservacion(cartera: string, contrato: string){
    let fechaActual = moment().format("D/M/YYYY");
    let activeUser = JSON.parse(localStorage.usuario);
    if(this.observacionesCartera.control.dirty && this.observacionesCartera.control.touched){
      this.observacionesCartera.control.markAsUntouched();
      this.observacionesCartera.control.markAsPristine();
      cartera = cartera.concat(`(${activeUser.nombre} ${activeUser.apellido} ${fechaActual})`);
      this.observacion_cartera = cartera;
    }
    if(this.observacionesContrato.control.dirty && this.observacionesContrato.control.touched){
      this.observacionesContrato.control.markAsUntouched();
      this.observacionesContrato.control.markAsPristine();
      contrato = contrato.concat(`(${activeUser.nombre} ${activeUser.apellido} ${fechaActual})`);
      this.observacion_contrato = contrato;
    }
    this._cartera.ActualizarObsGrupo(this._data.base_datos, this._data.grunit, this._data.grugru, cartera, contrato)
                  .subscribe((data: any) => {
                    if(data.affectedRows === 1){
                      this._snackBar.open('Observaciones del Grupo Actualizadas', 'Aceptar', {
                        duration: 2000,
                      });
                      this.disabled = true;
                    }else{
                      this._snackBar.open('Error al actualizar las observaciones', '', {
                        duration: 2000,
                        panelClass:  ['warn-600']
                      });
                    }
                  });
  }
}
